import { render, staticRenderFns } from "./CatTag.vue?vue&type=template&id=d33b1c34&scoped=true"
import script from "./CatTag.vue?vue&type=script&lang=js"
export * from "./CatTag.vue?vue&type=script&lang=js"
import style0 from "./CatTag.vue?vue&type=style&index=0&id=d33b1c34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b1c34",
  null
  
)

export default component.exports